import { useEffect } from 'react'

const useCloseKeyboardOnScroll = (containerRef) => {
  useEffect(() => {
    const listener = () => {
      const { activeElement } = document
      if (activeElement && activeElement.tagName === 'INPUT') {
        activeElement.blur()
      }
    }

    containerRef?.current?.addEventListener('touchmove', listener)

    return () => {
      containerRef?.current?.removeEventListener('touchmove', listener)
    }
  }, [containerRef])
}

export default useCloseKeyboardOnScroll
